<!-- Read-only: the mode and the allowance are set on the AI API (plan D25), not here. -->
<section class="panel">
  <div class="section-header">
    <h3>Plus Intelligence</h3>
    @if (policy) {
      <span [class]="modePill(policy.mode) + ' pill-sm'" [title]="modeHint(policy.mode)">{{ modeLabel(policy.mode) }}</span>
    }
  </div>

  @if (loading) {
    <span class="muted">Loading Plus Intelligence…</span>
  } @else if (unavailable) {
    <span class="muted">{{ unavailable }}</span>
  } @else {
    <div class="kv">
      <div class="kv-row">
        <span class="k">Billing mode</span>
        <span class="v">
          @if (policy) {
            {{ modeLabel(policy.mode) }}@if (modeHint(policy.mode)) { <span class="muted"> · {{ modeHint(policy.mode) }}</span> }
          } @else {
            <span class="muted">{{ policyError || '—' }}</span>
          }
        </span>
      </div>
      <!-- The intelligence agent's spend in the UTC month — the one figure the fair-use check compares with the allowance. -->
      <div class="kv-row" title="Plus Intelligence cases this month (UTC), as the fair-use check counts them">
        <span class="k">This month</span>
        <span class="v" [class.over]="overIncluded">{{ monthLine }}</span>
      </div>
      @if (hardCapUsd !== null) {
        <div class="kv-row">
          <span class="k">Hard cap</span>
          <span class="v">{{ usd(hardCapUsd) }}</span>
        </div>
      }
      <div class="kv-row">
        <span class="k">Cases this month</span>
        <span class="v">
          @if (usageError) {
            <span class="muted">{{ usageError }}</span>
          } @else {
            {{ cases.executions }}@if (cases.executions) { <span class="muted"> · {{ cases.succeeded }} completed · {{ cases.failed }} failed</span> }
          }
        </span>
      </div>
      @if (!usageError && allAgents.executions !== cases.executions) {
        <div class="kv-row">
          <span class="k">All agents this month</span>
          <span class="v">{{ allAgents.executions }} executions · {{ usd(allAgents.cost) }}</span>
        </div>
      }
    </div>

    @if (usedPct !== null) {
      <div class="meter" role="progressbar" aria-label="Included allowance used" [attr.aria-valuenow]="usedPct" aria-valuemin="0" aria-valuemax="100" [title]="usedPct + '% of the included allowance'">
        <div class="meter-fill" [class.over]="overIncluded" [style.width.%]="usedPct"></div>
      </div>
    }

    <p class="muted note-line">
      Read-only. Owners never pick a model; past the included allowance new cases are refused with a plain message, never downgraded.
    </p>
  }
</section>
